export const DEFAULT_PAGE_SIZE = 25;
export const UPDATE_ON_FORMAT = 'HH:mm aa, MMM dd yyyy';
export const DATE_FORMAT = 'MM-dd-yyyy';
export const phoneRegEx =
  /^((\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
